import AllContainers from "barcelo-components/containers";
import AdvComponents from "barcelo-components/adv";
import StructureComponents from "barcelo-components/structure";
import GenericComponents from "barcelo-components/generic";

const { container, accordion } = AllContainers;
const { ribbon, languageRibbon, translationEnabledLanguageDialog } = AdvComponents;
const { header, calendar, language, destination, discount, rooms, fastbooking, sticky, asideMenu, megaMenu, brands } = StructureComponents;
const { cta } = GenericComponents;

export default {
  container,
  accordion,
  ribbon,
  language,
  languageRibbon,
  translationEnabledLanguageDialog,
  megaMenu,
  asideMenu,
  sticky,
  header,
  calendar,
  destination,
  discount,
  rooms,
  fastbooking,
  cta,
  brands,
};
